import { HStack, Text, VStack, Box, Heading } from "@chakra-ui/react";
import { TicketTypeValues } from "./schema";
import dayjs from "dayjs";
import DatepickerFormInput from "../DatepickerFormInput";

const TicketTypeTimeline = ({
  timezone,
  loading = false,
}: {
  timezone: string;
  loading: boolean;
}) => {
  return (
    <VStack w="full">
      <Heading fontSize={"xl"} fontWeight={"semibold"} color="#1A202C" w="full">
        Timeline{" "}
        <Text as="span" fontSize={"xl"} fontWeight={"normal"}>
          (optional)
        </Text>
      </Heading>
      <HStack w="full" spacing={4}>
        <Box
          w="50%"
          bg="white"
          border="1px solid #E8E8E8"
          borderRadius="16px"
          p="24px"
        >
          <Text fontWeight={"medium"} mb="12px">
            On Sale → Off Sale Date
          </Text>
          <DatepickerFormInput<TicketTypeValues>
            skipValidate
            method="onChange"
            placeholder="On Sale Date and Time"
            name="on_sale_at"
            deps={["off_sale_at", "start_at", "end_at"]}
            timezone={timezone}
            dateTimeProps={{
              disabled: loading,
              disablePast: false,
              slotProps: {
                actionBar: {
                  actions: ["clear", "accept"],
                },
              },
            }}
          />
          <DatepickerFormInput<TicketTypeValues>
            method="onChange"
            skipValidate
            placeholder="Off Sale Date and Time"
            name="off_sale_at"
            timezone={timezone}
            deps={["on_sale_at", "start_at", "end_at"]}
            dateTimeProps={{
              disabled: loading,
              disablePast: true,
              slotProps: {
                actionBar: {
                  actions: ["clear", "accept"],
                },
              },
            }}
          />
        </Box>
        <Box
          w="50%"
          bg="white"
          border="1px solid #E8E8E8"
          borderRadius="16px"
          p="24px"
        >
          <Text fontWeight={"medium"} mb="12px">
            Valid From → Valid To Date
          </Text>
          <DatepickerFormInput<TicketTypeValues>
            skipValidate
            method="onChange"
            placeholder="Valid From Date and Time"
            name="start_at"
            timezone={timezone}
            dateTimeProps={{
              disablePast: true,
              disabled: loading,
              slotProps: {
                actionBar: {
                  actions: ["clear", "accept"],
                },
              },
            }}
          />
          <DatepickerFormInput<TicketTypeValues>
            skipValidate
            placeholder="Valid To Date and Time"
            name="end_at"
            method="onChange"
            timezone={timezone}
            dateTimeProps={{
              disabled: loading,
              disablePast: true,
              slotProps: {
                actionBar: {
                  actions: ["clear", "accept"],
                },
              },
            }}
          />
        </Box>
      </HStack>
    </VStack>
  );
};

export default TicketTypeTimeline;
